import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import ReactPaginate from "react-paginate";
import CircularProgress from "@mui/material/CircularProgress";

import {
  cart_actions,
  wishlist_actions,
  product_actions,
} from "../../../redux-store";
import ProductListItem from "./product-list-item";

const ProductListing = (props) => {
  const [page, setPage] = useState(1);
  const { limit } = props; 
  // const [limit, setLimit] = useState(12);

  const products = useSelector((state) => state.products.data);
  const totalProducts = useSelector((state) => state.products.total);
  const symbol = useSelector((state) => state.data.symbol);
  const user = useSelector((state) => state.auth.user);
  const isLoading = useSelector((state) => state.global.loading);
  const dispatch = useDispatch();

  useEffect(() => {
    fetchProducts();
  }, [page, limit]);

  const fetchProducts = () => {
    dispatch(
      product_actions.fetch_products({
        page,
        limit,
        merchant_user: user?.user?._id,
        published: true,
      })
    );
  };

  const handlePageChange = ({ selected }) => {
    setPage(selected + 1);
  };

  return (
    <div style={productListingStyle}>
      <div style={productListingContainerStyle}>
        <div className="product-wrapper-grid">
          <div className="container-fluid">
            {isLoading ? (
              <div style={loaderContainerStyle}>
                <CircularProgress sx={{ color: "#393230" }} />
              </div>
            ) : (
              <>
                {products.length > 0 ? (
                  <>
                    <div className="flex flex-wrap -mx-2"  style={gridStyle}>
                      {products.map((product, index) => (
                        <div
                        className={`col-md-6 col-lg-${
                          props.colSize === 5 ? 'custom-col-5' : Math.floor(12 / props.colSize)
                        } col-grid-box mb-4`}
                        key={index}
                        style={{ minWidth: "250px", marginBottom: "20px" }}
                      >
                      
                          <ProductListItem
                            product={product}
                            user={user}
                            symbol={symbol}
                            onAddToWishlistClicked={(unit) =>
                              dispatch(wishlist_actions.add_to_wishlist(unit))
                            }
                            onAddToCartClicked={(unit) =>
                              dispatch(cart_actions.add_to_cart(unit))
                            }
                          />
                        </div>
                      ))}
                    </div>
                    <div style={paginationContainerStyle}>
                      <ReactPaginate
                        previousLabel={"<<"}
                        nextLabel={">>"}
                        breakLabel={"..."}
                        pageCount={Math.ceil(totalProducts / limit)}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={5}
                        onPageChange={handlePageChange}
                        forcePage={page - 1} // zero-based index for ReactPaginate
                        containerClassName={"pagination"}
                        activeClassName={"active"}
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        previousClassName={"page-item"}
                        nextClassName={"page-item"}
                        previousLinkClassName={"page-link"}
                        nextLinkClassName={"page-link"}
                        breakClassName={"page-item"}
                        breakLinkClassName={"page-link"}
                      />
                    </div>
                  </>
                ) : (
                  <div className="row">
                    <div className="w-100 col-lg-12 col-md-12 col-sm-12 section-b-space mt-5 no-found text-center">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/images/empty-search.jpg`}
                        className="img-fluid mb-4"
                        alt="No products found"
                      />
                      <h3>
                        Sorry! Couldn't find the product you were looking for!
                      </h3>
                      <p>
                        Please check if you have misspelled something or try
                        searching with other words.
                      </p>
                      <Link
                        to={`${process.env.PUBLIC_URL}/`}
                        className="btn btn-solid"
                      >
                        Continue Shopping
                      </Link>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

// Inline styles for centering and layout
const productListingStyle = {
  display: "flex",
  justifyContent: "center",
  width: "100%",
};

const productListingContainerStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  // maxWidth: "1200px",
  width: "100%",
};

const loaderContainerStyle = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
};

const paginationContainerStyle = {
  display: "flex",
  justifyContent: "center",
  marginTop: "20px",
};

const gridStyle = {
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "flex-start",
};

export default withRouter(ProductListing);
